import { datadogRum } from "@datadog/browser-rum";
import type { ErrorComponentProps } from "@tanstack/react-router";
import { useEffect } from "react";

export function DatadogError({
  errorProps,
  render,
}: {
  errorProps: ErrorComponentProps;
  render: (props: ErrorComponentProps) => React.ReactNode;
}) {
  const { error } = errorProps;

  useEffect(() => {
    datadogRum.addError(error);
  }, [error]);

  return render(errorProps);
}
